// src/api/tournaments.ts
import { GameState } from "../constants/game";

export async function fetchUpcomingSessions(idToken: string, gameState: GameState) {
  // Add cache-busting parameter to prevent CDN caching
  const timestamp = Date.now();
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/getUpcoming${gameState}Sessions?_t=${timestamp}`, {
    credentials: 'include',
    headers: {
      'Authorization': `Bearer ${idToken}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch tournaments');
  }

  return response.json();
}

export async function fetchUpcomingJoinedSessions(idToken: string, gameState: GameState) {
  // Add cache-busting parameter to prevent CDN caching
  const timestamp = Date.now();
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/getUpcomingJoined${gameState}Sessions?_t=${timestamp}`, {
    credentials: 'include',
    headers: {
      'Authorization': `Bearer ${idToken}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch joined tournaments');
  }

  return response.json();
}

export async function joinSession(gameState: GameState, sessionId: number, idToken: string): Promise<void> {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/join${gameState}Session`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${idToken}`, 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ tournamentId: sessionId, gameId: sessionId }),
  });

  if (!response.ok) {
    const errorText = (await response.text()).trim();
    throw new Error(errorText || 'Join failed');
  }
}
  
export async function leaveSession(gameState: GameState, sessionId: number, idToken: string): Promise<void> {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/leave${gameState}Session`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${idToken}`, 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ tournamentId: sessionId, gameId: sessionId }),
  });

  if (!response.ok) throw new Error('Leave failed');
}
